import {BaseModel} from "./base-model";
import {FETCH_METHODS} from "../../core/consts";

export class BaseFetchModel extends BaseModel {
  method: FETCH_METHODS;
  headers: Object;

  constructor(method: String) {
    super();

    this.method = method;
  }

  get body(): String {
    const requestBody = {};

    return JSON.stringify(requestBody);
  }
}
